import Phaser from "phaser";

import {baseStyle} from "../configs/font-style";

export class PowerLabel extends Phaser.GameObjects.Text {
  /** @type {Monster} */
  monster;

  /** @param {Monster} monster */
  constructor(monster) {
    super(monster.scene, 0, 0, '', {
      ...baseStyle
    });

    this.monster = monster;
    this.scene.add.existing(this);
    this.scene.sys.updateList.add(this);
  }

  preUpdate() {
    if (!this.monster) return;
    this.x = this.monster?.x - this.monster?.width / 3;
    this.y = this.monster?.y + this.monster?.height / 3;
    const w = this.monster?.weapon > 0 ? `+${this.monster?.weapon}` : "";
    const a = this.monster?.armor > 0 ? `🛡️ ${this.monster?.armor} ` : " ";
    this.text = `⚔️ ${this.monster?.attack} ${w} ${a}❤️ ${this.monster?.life}`;
  }

  destroy(args) {
    delete this.monster;
    super.destroy();
  }
}
